import React from "react";
import { Box, Skeleton } from "@mui/material";
import { Surface } from "./Surface";

export interface CardSkeletonListProps {
  /** How many skeleton cards to render. */
  count?: number;
  /** Show a second, shorter line per card (for description-bearing rows). */
  twoLine?: boolean;
}

/**
 * Loading placeholder matching the `WorkspaceCard` footprint, so list pages
 * show shaped skeletons during the initial fetch instead of a bare centered
 * spinner. Improves perceived performance and avoids layout jump on load.
 */
export function CardSkeletonList({ count = 4, twoLine = true }: CardSkeletonListProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }} aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }).map((_, i) => (
        <Surface key={i} level="mid" sx={{ p: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Skeleton variant="rounded" width={36} height={36} />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Skeleton variant="text" width="45%" height={18} />
              {twoLine && <Skeleton variant="text" width="80%" height={14} />}
            </Box>
            <Skeleton variant="rounded" width={64} height={28} />
          </Box>
        </Surface>
      ))}
    </Box>
  );
}
